import React from "react";
import {Link} from "react-router-dom";
import projects from "../../../Works/AllWork.json";
import "./SmallCard.css";

class SmallCard extends React.Component {

  render(){
    return ( 
      <div>
      {projects.map((project, index) => {
        return index !== 0 && index < 3 ? (
        <div key={index} className="row">
          <div className="col mb-3">
            <a href={"/projectInfo/"  + project.projectId}> 
            <div className="small-card mb-3">
              <img className="small-card-img-top" src={project.projectImage} alt="Card image cap" />
              <div className="small-body">
                <h5 className="small-title">{project.projectName}</h5>
                <p className="small-text">{project.projectDescription}</p>
              </div>
            </div>
            </a>
          </div>
        </div> ) : null
      })}
    </div>
    );
  }
  
};

export default SmallCard;


// WEBPACK FOOTER //
// ./src/components/Mainpage/Work/SmallCard/SmallCard.js